import React from 'react';
import { Divider, Typography } from '@mui/material';
import kechoCompost from '../../../../../images/Agri-info/crops/vermi-compost_কেচোঁ কম্পোস্ট.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const KechoCompostInfo = () => {

    // dynamic title
    useDocumentTitle("কেচোঁ কম্পোস্ট");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                component="div"
            >
                কেচোঁ কম্পোস্ট
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={kechoCompost} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>কেচোঁ কম্পোস্ট (ভার্মি কম্পোস্ট)</b></p>
                            <p>কেচোঁ মানুষের একটি অন্যতম উপকারী প্রাকৃতিক ক্ষুদ্র প্রাণী। এ প্রাণী যে মাটি চাষাবাদের কাজে উপকারে আসে তা আমরা গুরুত্ব দিয়ে চিন্তা করিনি। প্রধানত কেচোঁ উপরের মাটি নিচে এবং নিচের মাটি উপরে তুলে থাকে। এসব কাজের সাথেই কেচোঁর সারও তৈরি হয়। কেচোঁর দ্বারা জৈব সার তৈরির জন্য এ সাথে তরকারির খোসা, গরু, ছাগল ও হাঁস-মুরগির বিষ্ঠা ও নাড়িভুড়ি, পাতাসহ পচা আবর্জনারও প্রয়োজন হয়।</p>
                            <p>কেচোঁ কম্পোস্ট তৈরি করতে হলে প্রথমে গর্ত তৈরি করতে হয়। এরপর এসব গর্তে ঘাস, আমের পাতা বা খামারের ফেলে দেয়া অংশ এসবের যেকোনো একটি ছোট ছোট করে কেটে এর প্রায় ২৫ কেজি হিসেবে নিতে হয়।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p>তবে বসেব আবর্জনা গর্তে ফেলার আগে গর্তেও তলদেশসহ চারপাশে পলিথিন দিয়ে মুড়ে দিতে হবে। এতে করে গর্তের কেচোঁ পিট থেকে বাইরে যেতে পারবে না।</p>
                <p>কেচোঁ কম্পোস্ট তৈরির জন্য প্রথমেই পলিথিন বিছানোর পরে গর্তের নিচে ১৫ সে. মিটার পুরু করে বেড বানাতে হবে। এ বেড তৈরির জন্য ভাল মাটি ও গোবর সমপরিমাণে মিশাতে হবে এবং এসব মিশানো গোবর ও মাটি পরে কেচোঁর খাবার হিসেবে ব্যবহৃত হয়।</p>
                <p>সাধারণত এসব কম্পোস্ট তৈরির কাজে দুই ধরনের কেচোঁর জাত রয়েছে। তাহলো-এপিজিক ও এন্ডোজিক নামের। এপিজিক জাতগুলো দেখতে লাল রংঙের এরা মাটির উপরের স্তরেই বিচরণ করে থাকে। এরা সাধারণত সার উৎপাদন করতে পারে না তবে এরা মাটির ভৌত ও জৈব গুণাবলির উন্নতি করে।<br />
                    কেচোঁ কম্পোস্ট তৈরির জন্য এসব গর্ত গোবর ও মাটি দিয়ে ভর্তি করার পর এতে প্রায় ২ হাজার কেচোঁ প্রয়োগ করতে হয়। কেচোঁ প্রয়োগের পর গর্তের উপরিভাগ পাটের ভিজানো চট দিয়ে ঢেকে দিতে হবে এবং সারের গুণগত মান বজায় রাখার জন্য গর্তেও উপরিভাগে ছায়া প্রদানের ব্যবস্থা খুবই জরুরি।</p>
                <p>এসব কেচোঁ যেসব খাবার খায় তা গর্তে নিয়মিতভাবে সরবরাহ করতে হবে। কেচোঁর খাবারের মধ্যে রয়েছে স্থানীয় ঘাস, খামারজাত পদার্থ, আখের ও কলার ফেলে দেয়া অংশ এসব। এয়াড়া এসব অংশ মাটিতে পচে জৈব সারও তৈরি হয়।</p>
                <p>অন্যান্য কম্পোস্ট তৈরির চেয়ে কেচোঁ কম্পোস্ট তৈরি করতে সময় কম লাগে। এছাড়া গবেষণায় দেখা গেছে একটি আদর্শ ভার্মিকম্পোস্ট ১.৫৭% নাইট্রোজেন, ১.২৬% ফসফরাস, ২.৬০% পটাশ, ০.৭৪% সালফার, ০.৬৬% ম্যাগনেশিয়াম, ০.০৬% বোরণ রয়েছে। এছাড়া কেচোঁ কম্পোস্টে অন্যান্য কম্পোস্টের চেয়ে প্রায় ৭-১০ ভাগ পুষ্টিমান বেশি থাকে।</p>
                <p>সাধারণত পিপঁড়া, উইপোকা, তেলেপোকা, মুরগী, ইঁদুর পানি এসব কেচোঁর বড় শত্রু। এরা যেন কেচোঁর কাছে আসতে পারে সেদিকে লক্ষ্য রাখতে হবে।</p>

            </div>
        </div >

    );
};

export default KechoCompostInfo;